import { useContext } from 'react'

import {
  CarouselOrListingBlock,
  CarouselOrListingBlockProps,
} from 'components/molecules/carouselOrListingBlock'
import { CarouselOrListingBlockSliderProps } from 'components/molecules/carouselOrListingBlock/slider'
import { CarePathDefaultContext } from 'components/templates/carePath/landing/context'

import useStyles from './index.styles'

export const _CarouselOrListingBlockWrapper = (
  props: CarouselOrListingBlockProps,
) => {
  return <CarouselOrListingBlock {...props} />
}

export const _CarouselOrListingBlockSlider = (
  props: CarouselOrListingBlockSliderProps,
) => {
  const { activeTheme } = useContext(CarePathDefaultContext)
  const { classes } = useStyles({ color: activeTheme?.primary })
  return (
    <CarouselOrListingBlock.Slider
      {...props}
      classNames={{
        arrow: classes.arrow,
        arrowIcon: classes.arrowIcon,
        ...props.classNames,
      }}
    />
  )
}

export interface CompoundedComponent
  extends React.ForwardRefExoticComponent<CarouselOrListingBlockProps> {
  Slider: typeof _CarouselOrListingBlockSlider
  Paging: typeof CarouselOrListingBlock.Paging
}

const CarouselOrListingBlockWrapper = _CarouselOrListingBlockWrapper as CompoundedComponent
CarouselOrListingBlockWrapper.Slider = _CarouselOrListingBlockSlider
CarouselOrListingBlockWrapper.Paging = CarouselOrListingBlock.Paging

export { CarouselOrListingBlockWrapper }
